$bog_ainews_app_filters $bog_ainews_app_page
	title @ \Filters
	body /
		<= Include_labeler $mol_labeler
			title @ \Post must include text:
			content /
				<= Include_string $mol_string
					value? <=> include_string_value? \
					hint \Visual
				<= Include_string_clear_button $mol_button_minor
					click? <=> include_string_clear_click? null 
					sub /
						<= Include_string_close_icon $mol_icon_close
		<= Excldue_labeler $mol_labeler
			title @ \Post must exclude text:
			content /
				<= Exclude_string $mol_string
					value? <=> exclude_string_value? \
					hint \AI,II
				<= Exclude_string_clear_button $mol_button_minor
					click? <=> exclude_string_clear_click? null
					sub /
						<= Exclude_string_close_icon $mol_icon_close
		<= Tip_labeler $mol_labeler
			title @ \Tip:
			content /
				<= Tip $mol_paragraph title @ \You can use a comma for multiple word instructions: AI,AGI
